<app-loader></app-loader>
<app-authorization-type-modal></app-authorization-type-modal>
<router-outlet></router-outlet>
<div class="vigilado" *ngIf="showFooter">
  <img loading="lazy" src="https://staallianzportalv1dev.blob.core.windows.net/allianz-portal-assets/Vigilado.png"alt="">
</div>
